module.exports = __webpack_public_path__ + "static/media/Control_Your_PC.44c96b85.svg";